import { generatePath, useHistory, useParams } from 'react-router-dom';

import { AffiliatesContainer } from './AffiliatesSection.styles';
import { Divider } from 'features/common/components/Divider';
import { FC } from 'react';
import { FlexContainer } from 'features/common/components/FlexContainer';
import { IdParamsType } from 'utils/types';
import { QUERY_KEYS_NO_FETCHING as QUERY_KEYS } from 'utils/constants';
import { ROUTES } from 'features/routes';
import { SectionContent } from './SectionContent';
import { SectionTitle } from 'features/common/components/SectionTitle';
import { StyledLoader } from 'features/common/animations/Loader/Loader.styles';
import { useGetAffiliates } from 'hooks/useGetAffiliates/useGetAffiliates';
import { useResponsiveScreen } from 'hooks/useWindowSize';
import { useTranslation } from 'react-i18next';

export const AffiliatesSection: FC = () => {
	const { t } = useTranslation();
	const { push } = useHistory();
	const { id }: IdParamsType = useParams();
	const isLargeScreen = useResponsiveScreen();

	const pushToPath = (path: string, id: string) => push(generatePath(path, { id }));

	const { affiliates, affiliateCt } = useGetAffiliates({
		queryKey: [QUERY_KEYS.DASHBOARD_AFFILIATES],
		eventId: id,
		perPage: -1,
	});

	return (
		<>
			<SectionTitle
				title={t('dashboard-affiliates')}
				buttonLabel={t('dashboard-add')}
				onClick={() => pushToPath(ROUTES.DASHBOARD_NEW_AFFILIATE, id)}
			/>
			<AffiliatesContainer>
				{affiliates.isLoading ? (
					<FlexContainer justifyContent="center" alignItems="center" width="100%">
						<StyledLoader />
					</FlexContainer>
				) : (
					<SectionContent affiliateCt={affiliateCt} id={id} pushToPath={pushToPath} t={t} />
				)}
			</AffiliatesContainer>
			{!isLargeScreen && <Divider />}
		</>
	);
};
